<template>
  <ArtisanGrid ref="part" metaKey="JcPartInfo" :query="query">
    <template #duration="{ row }">
      <el-input-number
        v-model="row.duration"
        :controls="false"
        :min="0"
        :max="60"
        size="mini"
        style="width: 100%"
        @change="change(row)"
      ></el-input-number>
    </template>
  </ArtisanGrid>
</template>

<script>
import { editPart } from "@/api/jc/project";
export default {
  props: ["query"],
  methods: {
    change(row) {
      editPart(row).then((res) => {});
    },
  },
};
</script>

<style>
</style>